"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRadioStationConfig = void 0;
const common_v2_model_1 = require("./common-v2.model");
const common_model_1 = require("./common.model");
exports.defaultRadioStationConfig = {
    type: common_model_1.StreamingPlayerType.RADIO_STATION,
    id: '',
    private: false,
    formats: [common_model_1.StreamingPlayerFileFormat.MP3],
    api: {
        endpoint: '',
        type: common_model_1.StreamingPlayerAPIType.ONDEMAND,
    },
    ui: common_v2_model_1.defaultUIConfiguration,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmFkaW8tc3RhdGlvbi12Mi5tb2RlbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2RlbHMvcmFkaW8tc3RhdGlvbi12Mi5tb2RlbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSx1REFBNks7QUFDN0ssaURBQXdHO0FBVTNGLFFBQUEseUJBQXlCLEdBQXlDO0lBQzdFLElBQUksRUFBRSxrQ0FBbUIsQ0FBQyxhQUFhO0lBQ3ZDLEVBQUUsRUFBRSxFQUFFO0lBQ04sT0FBTyxFQUFFLEtBQUs7SUFDZCxPQUFPLEVBQUUsQ0FBQyx3Q0FBeUIsQ0FBQyxHQUFHLENBQUM7SUFDeEMsR0FBRyxFQUFFO1FBQ0gsUUFBUSxFQUFFLEVBQUU7UUFDWixJQUFJLEVBQUUscUNBQXNCLENBQUMsUUFBUTtLQUN0QztJQUNELEVBQUUsRUFBRSx3Q0FBc0I7Q0FDM0IsQ0FBQyJ9